// client/src/dnd/emitter_tool/hooks/overlay/shapes/common.js

// Convert a CSS-space point (relative to the PIXI view) into stage/device space.
export function cssToStage(app, xCss, yCss) {
  const res = Number(app?.renderer?.resolution) || 1;
  const sx  = Number(app?.stage?.scale?.x) || 1;
  const sy  = Number(app?.stage?.scale?.y) || 1;
  return { x: xCss * res * sx, y: yCss * res * sy };
}

// Convert absolute window client coords into stage/device space via view's rect.
export function clientToStage(app, clientX, clientY) {
  if (!app?.view || typeof app.view.getBoundingClientRect !== "function") {
    return { x: 0, y: 0 };
  }
  const rect = app.view.getBoundingClientRect(); // same source TargetingManager uses
  const xCss = clientX - rect.left;
  const yCss = clientY - rect.top;
  return cssToStage(app, xCss, yCss);
}
